module.exports = __webpack_public_path__ + "img/t4-7.612df565.svg";